<template>
  <div class="page-container">
   

      <div class="timeline">
        <div class="timeline-item" v-for="event in companyTexts.events.timeline" :key="event.year">
          <div class="timeline-year">{{ event.year }}</div>
          <div class="timeline-content-wrapper">
            <div class="timeline-events">
              <ul>
                <li v-for="item in event.items" :key="item">{{ item }}</li>
              </ul>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'CompanyEvents',
  setup() {
    const { tm } = useI18n();
    const companyTexts = computed(() => {
      return tm('pages.company') as any;
    });
    return {
      companyTexts,
    };
  },
});
</script>

<style scoped lang="scss">
.page-container {
    font-weight: 300;
    padding: 20px 30px 40px 70px;
    max-height: calc(100vh - 150px);
    overflow-y: auto;
    
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;
      
      &:hover {
        background: #a8a8a8;
      }
    }

  .banner {
    position: relative;
    text-align: center;
    color: white;
    background-color: #004080; // Added a background color as placeholder if image is missing
    padding: 40px 20px; // Added padding for banner text visibility
    min-height: 200px; // Ensure banner has some height
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 0; // Ensure image is behind text
    }
    .banner-text {
      position: relative; // Changed from absolute to relative for better flow with padding
      z-index: 1; // Ensure text is above image
      h1 {
        font-size: 2.8rem;
        margin-bottom: 0.8rem;
        font-weight: bold;
      }
      p {
        font-size: 1.3rem;
      }
    }
  }


  .timeline {
    position: relative;
    padding-left: 60px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 20px;
      bottom: 20px;
      width: 4px;
      background-color: #d0d7de;
      border-radius: 2px;
    }
  }

  .timeline-item {
    position: relative;
    margin-bottom: 30px;
    display: flex;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .timeline-year {
    position: absolute;
    left: -88px;
    top: 5px;
    width: auto;
    min-width: 60px;
    padding: 8px 10px;
    font-size: 0.9rem;
    font-weight: bold;
    color: #fff;
    background: linear-gradient(to bottom right, #c8e3f0 0%, #62B5F8 100%);
    border-radius: 20px;
    text-align: center;
    z-index: 2;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  }

  .timeline-content-wrapper {
    flex-grow: 1;
    margin-left: 20px;
    padding: 15px 20px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    text-align: left;
  }

  .timeline-events {
    text-align: left;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        position: relative;
        padding-left: 20px;
        margin-bottom: 12px;
        line-height: 1.7;
        color: #555;
        word-break: break-word;
        hyphens: auto;
        text-align: left;

        &::before {
          content: '\2022';
          position: absolute;
          left: 0;
          top: 0;
          color: #007bff;
          font-size: 1.4em;
          line-height: inherit;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

/* Responsive adjustments */
@media (max-width: 992px) {
   .timeline-item {
      width: calc(50% - 30px);
       &:nth-child(odd) {
        padding-right: 30px;
         .timeline-year::before {
            left: -38px;
         }
       }
       &:nth-child(even) {
        left: calc(50% + 30px);
        padding-left: 30px;
        .timeline-year::before {
            right: -38px;
         }
       }
   }
}

/* 移动端优化 */
@media (max-width: 768px) {
  .page-container {
    padding: 10px 15px 20px 15px !important;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
    
    .banner .banner-text h1 { 
      font-size: 2.2rem; 
    }
    .banner .banner-text p { 
      font-size: 1.1rem; 
    }
  }

  .timeline {
    padding-left: 30px !important;
    padding-top: 10px;
    
    &::before {
      content: '';
      position: absolute;
      left: 15px;
      top: 10px;
      bottom: 10px;
      width: 2px;
      background-color: #d0d7de;
      border-radius: 1px;
    }
  }
  
  .timeline-item {
    width: 100% !important;
    left: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    margin-bottom: 20px;
    position: relative;
    
    &::before {
      display: none;
    }
  }
  
  .timeline-year {
    position: static !important;
    left: auto !important;
    top: auto !important;
    transform: none !important;
    display: inline-block;
    font-size: 0.9rem;
    padding: 8px 16px;
    min-width: auto;
    width: auto;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 25px;
    margin-bottom: 15px;
    white-space: nowrap;
    box-shadow: 0 3px 8px rgba(0,0,0,0.15);
    color: #fff;
    font-weight: 600;
  }
  
  .timeline-content-wrapper {
    margin-left: 0;
    margin-top: 0;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 15px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    border: 1px solid #f0f0f0;
    width: 100%;
    box-sizing: border-box;
  }

  .timeline-events {
    order: 2 !important;
    width: 100%;
    text-align: left !important;
    align-items: flex-start !important;
    
    ul {
      margin: 0;
      padding: 0;
      
      li {
        padding-left: 15px;
        margin-bottom: 10px;
        font-size: 0.9rem;
        line-height: 1.7;
        color: #444;
        
        &::before {
          font-size: 1.1em;
          color: #667eea;
          font-weight: bold;
        }
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

/* 超小屏幕优化 */
@media (max-width: 480px) {
  
  .page-container {
    padding: 8px 20px 15px 12px !important;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
  }
  
  .timeline {
    padding-left: 25px !important;
    
    &::before {
      left: 12px;
    }
  }
  
  .timeline-item {
    padding-left: 0 !important;
    margin-bottom: 16px;
    
    &::before {
      display: none;
    }
  }
  
  .timeline-year {
    font-size: 0.85rem;
    padding: 6px 12px;
    margin-bottom: 12px;
  }
  
  .timeline-content-wrapper {
    padding: 16px;
    border-radius: 12px;
  }
  
  .timeline-events ul li {
    font-size: 0.85rem;
    padding-left: 12px;
    margin-bottom: 8px;
  }
}
</style> 